import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const ChristmasTreeOutlined = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "m19.706 15.45-3.369-4.19h1.11a.624.624 0 0 0 .512-.986L11.042.562a1.248 1.248 0 0 0-2.084 0L2.041 10.25a.625.625 0 0 0 .511 1.012h1.11L.295 15.449a1.249 1.249 0 0 0 .973 2.054h4.99v1.248A1.25 1.25 0 0 0 7.506 20h4.99a1.247 1.247 0 0 0 1.248-1.248v-1.249h4.99a1.247 1.247 0 0 0 .973-2.054Zm-15.844-.444 4.99-6.242H6.19L10 3.396l3.811 5.368h-2.663l4.99 6.242h-4.89v1.873a.625.625 0 0 1-.624.624H9.377a.624.624 0 0 1-.624-.624v-1.873h-4.89Z" }) }));
});
ChristmasTreeOutlined.displayName = 'ChristmasTreeOutlined';
ChristmasTreeOutlined.__iconComponentType = 'standard';
export default ChristmasTreeOutlined;
//# sourceMappingURL=ChristmasTreeOutlined.js.map